<template>
  <div class="main-wrapper">
    <!-- <div class='products'>
      <div class='container'>
        <div class='row flow-offset-2'>
          <div class='col-md-4 product' v-for='(product, idx) in productsData' v:class='product.title | lowercase' :key="idx">
            <div class='image' @click='viewProduct(product, idx)' v-bind:style='{backgroundImage: getImageStyle(product.image)}' style='background-size: cover; background-position: center;'></div>
            <div class='name'>{{ product.title }}</div> <br>
            <p style='color:#614051;'>{{ product.description_heading }}</p>
            <div class='description'>{{ product.description }}</div> <br>
            <p style='color:#614051;'>{{ product.short_description_heading }}</p>
            <div class='short_description'>{{ product.short_description }}</div>
            <div class='price'>{{ product.price | currency }}</div>
            <div class='pull-right'>
            <button @click='addToCart(product)' class='pull-right'>Add to Cart</button></div>
          </div>
        </div>
      </div>
    </div> -->
    <div class='products'>
     <div class='container'>
       <div class='row flow-offset-2'>
        <!-- <div class="col-md-12">
          <h2 data-text="Products"></h2>
        </div> -->
         <div class='col-md-12 product mrg-top-30' >
           <div class='row' >
             <div class="col-md-2 text-left left-sidebar">
              <div class="category">
               <h3>Categories</h3>
               <ul>
                <li v-on:click="categoryValue = 'all'" v-bind:class="{ active: categoryValue == 'all' }" >All</li>
                <li v-for='(category, idx) in productsCategory' v-bind:class="{ active: categoryValue == category.id }" v:class='category.name | lowercase' :key="idx" v-on:click='categoryValue = category.id'>{{category.name}}</li>
               </ul>
              </div>
              <div class="brand"> 
               <h3>Brands</h3>
               <ul>
                <li v-on:click="brandValue = 'all'" v-bind:class="{ active: brandValue == 'all' }">All</li>
                <li  v-for='(brand, idx) in productsBrand' v:class='brand.name | lowercase' :key="idx" v-bind:class="{ active: brandValue == brand.id }" v-on:click='brandValue = brand.id'>{{brand.name}}</li>
               </ul>
              </div> 
             </div>
             <div class="col-md-10 text_center_small" >
              <div class="row" v-for='(product, idx) in filteredProduct' v:class='product.title | lowercase' :key="idx">
               <div class='col-md-4 align-self-center'>
                 <div class='image' @click='viewProduct(product, idx)' v-bind:style='{backgroundImage: getImageStyle(product.image)}' style='background-size: contain; background-position: center center; background-repeat: no-repeat; border: 1px solid #ededed;'></div>
               </div>
               <div class='col-md-6'>
                  <p class='name text_center_small'>{{ product.title }} <br> </p>
                  <div class='description text_center_small'>{{ product.description }}</div>
               </div>
               <div class="col-md-2">
                 <p class='price  text_center_small'>{{ product.price | currency }}</p>
                 <button @click='addToCart(product)' class=' add-card-btn text_center_small'>Add to Cart</button>
               </div>
             </div>
           </div>
           </div>
         </div>
       </div>
     </div>
   </div>
    <div class='modalWrapper' v-show='showModal'>
      <div class='prevProduct' @click='changeProductInModal("prev")'><i class='fa fa-angle-left'></i></div>
      <div class='nextProduct' @click='changeProductInModal("next")'><i class='fa fa-angle-right'></i></div>
      <div class='overlay' @click='hideModal()'></div>
      <div class='modal'>
        <i class='close fa fa-times' @click='hideModal()'></i>
        <div class='imageWrapper'>
          <div class='image' v-bind:style='{backgroundImage: getImageStyle(modalData.image)}' style='background-size: cover; background-position: center;' v-on:mouseover='imageMouseOver($event)' v-on:mousemove='imageMouseMove($event)' v-on:mouseout='imageMouseOut($event)'></div>
        </div>
        <div class='additionalImages' v-if='modalData.images'>
          <div v-for='(image, idx) in modalData.images' class='additionalImage' v-bind:style='{backgroundImage: getImageStyle(image)}' style='background-size: cover; background-position: center;' @click='changeImage(image)' :key="idx"></div>
          
        </div>
        <div class='name'>{{ modalData.product }}</div>
        <div class='description'>{{ modalData.description }}</div>
        <div class='details'>{{ modalData.details }}</div>
        <h3 class='price'>{{ modalData.price | currency }}</h3>
        <label for='modalAmount'>QTY</label>
        <input id='modalAmount' v-model='modalAmount' class='amount' @keyup.enter='modalAddToCart(modalData), hideModal()'/>
        <button @click='modalAddToCart(modalData), hideModal()'>Add to Cart</button>
      </div>
    </div>
  </div>
</template>

<script>
  import common from '../common';
  import {bus} from '../main';
  var {api} = common;

  export default {
  name: "ProductList",
  props: ['productsData', 'productsCategory', 'productsBrand'],
  data: function() {
    return {
      showModal: false,
      modalData: {},
      modalAmount: 1,
      timeout: "",
      mousestop: "",
      categoryValue: 'all',
      brandValue: 'all',
    }
  },

  filters: {
    currency: function(price){
      return '$' + price;
    },
  },
  computed: {
    categoryFilteredProduct: function() {
      var vm = this;
      var category = vm.categoryValue;
      //var brand = vm.brandValue;

      if(category === "all") {
        return vm.productsData;
      } else {
        return vm.productsData.filter(function(cat) {
          return cat.category === category;
        });
      }
    },
    filteredProduct: function() {
      var vm = this;
      //var category = vm.categoryValue;
      var brand = vm.brandValue;

      if(brand === "all") {
        return vm.categoryFilteredProduct;
      } else {
        return vm.categoryFilteredProduct.filter(function(cat) {
          return cat.brand === brand;
        });
      }
    }
  },

  methods: {
    getImageStyle: function(img){
      img = img ? img.split(',')[0] : img;
      return "url(" + api + "uploads/" + img + ")";
    },
    addToCart: function(product) {
      bus.$emit('addToCart', product);
    },

    modalAddToCart: function(modalData) {
      for(var i = 0; i < this.modalAmount; i++) {
        this.addToCart(modalData);
      }
      this.modalAmount = 1;
    },

    viewProduct: function(product, idx) {
      product = {...product};
      product.idx = idx;
      this.modalData = product;
      this.showModal = true;
    },

    changeProductInModal: function(direction) {
      var productsLength = this.productsData.length,
          currentProduct = this.modalData.idx,
          newProductId;

      if(direction === "next") {
        newProductId = currentProduct + 1;
        if(currentProduct >= productsLength) {
          newProductId = 1;
        }

      } else if(direction === "prev") {
        newProductId = currentProduct - 1;

        if(newProductId === 0) {
          newProductId = 0;
        }
      }

      for (var i = 0; i < productsLength; i++) {
        if (i === newProductId) {
          this.viewProduct(this.productsData[i], i);
        }
      }
    },

    hideModal: function() {
      this.modalData = {};
      this.showModal = false;
    },

    changeImage: function(image) {
      this.modalData.image = image;
    },

    imageMouseOver: function(event) {
      event.target.style.transform = "scale(2)";
    },

    imageMouseMove: function(event) {
      event.target.style.transform = "scale(2)";
      
      this.timeout = setTimeout(function() {
        event.target.style.transformOrigin = ((event.pageX - event.target.getBoundingClientRect().left) / event.target.getBoundingClientRect().width) * 100 + '% ' + ((event.pageY - event.target.getBoundingClientRect().top - window.pageYOffset) / event.target.getBoundingClientRect().height) * 100 + "%";
      }, 50);
      
      this.mouseStop = setTimeout(function() {
        event.target.style.transformOrigin = ((event.pageX - event.target.getBoundingClientRect().left) / event.target.getBoundingClientRect().width) * 100 + '% ' + ((event.pageY - event.target.getBoundingClientRect().top - window.pageYOffset) / event.target.getBoundingClientRect().height) * 100 + "%";
      }, 100);
    },

    imageMouseOut: function(event) {
      event.target.style.transform = "scale(1)";
    }
  }
}
</script>

<style scoped>
.category{
  margin-bottom:40px;
}
.category ul li{
  border-bottom:1px solid #efefef;
  padding-bottom:5px;
  padding-left:5px;
  cursor:pointer;
}

.category ul li:hover{
  background-color: #efefef;
  border-left: 1px solid #800a00;
}
.category ul li:active{
  background-color: #efefef;
  border-left: 1px solid #800a00;
}

.category ul li.active{
  background-color: #efefef;
  border-left: 1px solid #800a00;
}

.brand ul li{
  border-bottom:1px solid #efefef;
  padding-bottom:5px;
  padding-left:5px;
  cursor:pointer;
}
.brand ul li:hover{
  background-color: #efefef;
  border-left: 1px solid #800a00;
}

.brand ul li.active{
  background-color: #efefef;
  border-left: 1px solid #800a00;
}

.brand ul li:active{
  background-color: #efefef;
  border-left: 1px solid #800a00;

}


/*sticky sidebar */


@media only screen and (min-width: 1024px) {
  .left-sidebar{
    position: -webkit-sticky;
    position: sticky;
    top: 15%;
  }
}
</style>